import { lazyArea } from "@baton/i18n";

/**
 * 028's English catalogue (014 `contracts/catalogue.md` § Areas, the `portal` row): the Tickets
 * screens, the portal shell a client member opens, the ticket invite page, the portal's activity
 * sentences and entity labels, and the problems its routes return. Declared as a lazy area
 * (`packages/i18n/src/catalogue.ts`) so the words ride in the portal's own chunks, the public entry's
 * invite page among them, and never in the application's first load.
 */
export const PORTAL_AREA = lazyArea("portal", () => import("@baton/i18n/catalogues/en/portal.json").then((module) => module.default));
